export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";